import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'WeatherModule',
  components: {
    Loading
  },
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState({
      active: state => state.sclWeatherModule.active,
      values: state => state.sclWeatherModule.values,
      isModify: state => state.sclWeatherModule.isModify
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    layoutSizeList () {
      return Constants.Layout.ButtonSize
    },

    // input
    posX: {
      get () {
        return this.values.posX
      },
      set (value) {
        this.setInputValue({
          keys: ['posX'],
          value: value
        })
      }
    },
    posY: {
      get () {
        return this.values.posY
      },
      set (value) {
        this.setInputValue({
          keys: ['posY'],
          value: value
        })
      }
    },
    layoutSizeType: {
      get () {
        return this.values.layoutSizeType
      },
      set (value) {
        this.setInputValue({
          keys: ['layoutSizeType'],
          value: value
        })
      }
    },

    // validate
    disablePostButton () {
      if (this.filterMode === 0) return false
        return false
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      hide: 'sclWeatherModule/hide',
      reset: 'sclWeatherModule/reset',
      setLayer: 'screenConfigLayout/setLayer',
      removeLayer: 'screenConfigLayout/removeLayer'
    }),
    ...mapMutations({
      setInputValue: 'sclWeatherModule/setInputValue'
    }),

    init () {
      // this.loading = true
    },

    /**
     * レイヤー情報を設定
     */
    postData () {
      this.setLayer(this.values)
      this.hide()
    },
    /**
     * レイヤー情報を削除
     */
    removeData () {
      this.removeLayer(this.values)
      this.hide()
    },

    /**
     * テキストエリアでEnterキー押下の処理
     */
    onKeydownEnter(keyCode) {
      if (keyCode !== 13) return
      this.postData()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}